import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from '@mui/material';
import ButtonBase from '@mui/material/ButtonBase';
import * as React from 'react';
import { Skeleton } from '../skeleton';
const ImageWrapper = styled('div')((props) => ({
    position: 'relative',
    width: props.width ?? '100%',
    height: props.height ?? '100%',
    display: 'inline-block'
}));
const ImageButton = styled(ButtonBase)((props) => ({
    position: 'relative',
    width: props.width ?? '100%',
    height: props.height ?? '100%',
    display: 'block'
}));
const StyledImage = styled('img')(({ theme, objectFit }) => ({
    width: '100%',
    height: '100%',
    display: 'block',
    objectFit: objectFit ?? 'cover',
    borderRadius: theme.shape.borderRadius
}));
export const Image = React.forwardRef((props, ref) => {
    const { src, loading = 'lazy', objectFit = 'cover', role, alt, skeleton = true, onLoad, onError, onClick, width, height, ...rest } = props;
    const [isLoaded, setIsLoaded] = React.useState(false);
    const [hasError, setHasError] = React.useState(false);
    const handleLoad = (event) => {
        setIsLoaded(true);
        onLoad?.(event);
    };
    const handleError = (event) => {
        setIsLoaded(true);
        setHasError(true);
        onError?.(event);
    };
    const imageElement = (_jsx(StyledImage, { ref: ref, src: src, "data-role": "image", loading: loading, role: role, alt: alt, onLoad: handleLoad, onError: handleError, objectFit: objectFit, ...rest }));
    return (_jsxs(ImageWrapper, { width: width, height: height, children: [skeleton && !isLoaded && !hasError && (_jsx(Skeleton, { variant: "rectangular", width: width ?? '100%', height: height ?? '100%', sx: {
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    borderRadius: 1
                } })), onClick ? (_jsx(ImageButton, { focusRipple: true, onClick: onClick, "data-role": "image-button", width: width ?? '100%', height: height ?? '100%', children: imageElement })) : (imageElement)] }));
});
